import Vue from "vue";
import Router from "vue-router";

import LoginLayout from "@/layout/LoginLayout.vue";
import HomeIndex from "@/views/index";
import DashboardIndex from "@/views/dashboard/index";
import MobileIndex from "@/views/mobile/index";
import OrderIndex from "@/views/order/index";
import GrankIndex from "@/views/grank/index";
import TeamFansIndex from "@/views/teamFans/index";
import DygaoyongIndex from "@/views/dygaoyong/index";
import DytuanzhangIndex from "@/views/dytuanzhang/index";
import GaoyongIndex from "@/views/gaoyong/index";
import CdfSunriseIndex from "@/views/cdfSunrise/index";
import TaobaoLiveIndex from "@/views/taobaoLive/index";
import AccountManage from '@/views/accountManage/index'

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);
const routes = [
  // 登录
  {
    path: "/",
    component: LoginLayout,
    redirect: "/login",
    hidden: true,
    meta: {
      title: "登录",
    },
    children: [
      {
        path: "/login",
        name: "Login",
        component: () => import("@/views/userLogin/index"),
        meta: {
          title: "登录",
        },
      },
    ],
  },
  {
    path: "/dashboard",
    component: DashboardIndex,
    name: "DashboardIndex",
    meta: {
      title: "控制台",
    },
  },
  {
    path: "/home",
    component: HomeIndex,
    name: "HomeIndex",
    meta: {
      title: "批量转链",
    },
  },
  {
    path: "/mobile",
    component: MobileIndex,
    name: "MobileIndex",
    meta: {
      title: "",
    },
  },
  {
    path: "/order",
    component: OrderIndex,
    name: "OrderIndex",
    meta: {
      title: "订单管理",
    },
  },
  {
    path: "/grank",
    component: GrankIndex,
    name: "GrankIndex",
    meta: {
      title: "带货榜单",
    },
  },
  {
    path: "/team-fans",
    component: TeamFansIndex,
    name: "TeamFansIndex",
    meta: {
      title: "团队成员",
    },
  },
  {
    path: "/dygaoyong",
    component: DygaoyongIndex,
    name: "DygaoyongIndex",
    meta: {
      title: "抖音高佣库",
    },
  },
  {
    path: "/dytuanzhang",
    component: DytuanzhangIndex,
    name: "DytuanzhangIndex",
    meta: {
      title: "抖客团长库",
    },
  },
  {
    path: "/gaoyong",
    component: GaoyongIndex,
    name: "GaoyongIndex",
    meta: {
      title: "抖音CPM库",
    },
  },
  {
    path: "/taobao-live",
    component: TaobaoLiveIndex,
    name: "TaobaoLiveIndex",
    meta: {
      title: "淘宝直播库",
    },
  },
  {
    path: "/cdf-sunrise",
    component: CdfSunriseIndex,
    name: "CdfSunriseIndex",
    meta: {
      title: "中免日上库",
    },
  },
  {
    path: "/account",
    component: AccountManage,
    name: "AccountManage",
    meta: {
      title: "账号管理",
    },
  },
];
const router = new Router({
  mode: "hash",
  routes,
});

export { router };
